import React from 'react'
import { Link } from 'react-router-dom'
import useFetch from '../../Hooks/useFetch'

function Page_header({ headertitle, subheader, Imagefile, ImageUrl, type }) {
  let HeaderTitle = headertitle
  let publicUrl = process.env.PUBLIC_URL + '/'
  let Subheader = subheader ? subheader : HeaderTitle
  const inlineStyle = {
    ...(type === 'project' && { height: '100vh' }),
    backgroundImage: ImageUrl ? `url(${ImageUrl})` : `url(${Imagefile})`,
    backgroundColor: 'rgba(0,0,0,0.2)',
    backgroundBlendMode: 'overlay',
    //   backgroundImage:
    //     "url(http://azca.pk/wp-content/uploads/2020/02/cover-image-28.jpg)",
  }
  return (
    <div className='breadcrumb-area jarallax' style={inlineStyle}>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='breadcrumb-inner'>
              <h1 className='page-title'>{HeaderTitle}</h1>
              <ul className='page-list'>
                <li>
                  <Link to='/'>Home</Link>
                </li>
                <li>{Subheader}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page_header
